// ----------------------------------------------------------------------------
// Component: Jazz HR
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';

// Styles
import './_lever.scss';

// Create url to fetch
const url = 'https://api.lever.co/v0/postings/earthrated?group=team&mode=json';

//Checking for potential Lever source or origin parameters
const pageUrl = window.location.href;
let leverParameter = '';
const trackingPrefix = '?lever-';

if (pageUrl.indexOf(trackingPrefix) >= 0) {
    // Found Lever parameter
    const pageUrlSplit = pageUrl.split(trackingPrefix);
    leverParameter = `?lever-${pageUrlSplit[1]}`;
}

//Functions for checking if the variable is unspecified
function cleanString(string) {
    if (string) {
        const cleanString = string.replace(/\s+/ig, "");
        return cleanString;
    } else {
        return "Uncategorized";
    }
}

function nullCheck(string) {
    if (!string) {
        const result = 'Uncategorized';
        return result;
    } else {
        return string;
    }
}

function createJobs(_data) {
    for (let i = 0; i < _data.length; i++) {
        for (let j = 0; j < _data[i].postings.length; j++) {
            const posting = _data[i].postings[j];
            const title = posting.text;
            const location = nullCheck(posting.categories.location);
            const locationCleanString = cleanString(location);
            const commitment = nullCheck(posting.categories.commitment);
            const commitmentCleanString = cleanString(commitment);
            const team = nullCheck(posting.categories.team);
            const teamCleanString = cleanString(team);
            const workplaceType = nullCheck(posting.workplaceType);
            const workplaceTypeCleanString = cleanString(workplaceType);
            const link = posting.hostedUrl + leverParameter;

            const jobsListContainer = document.querySelector('#jobs-container .jobs-list');
            const job = document.createElement('div');
            const jobDetails = document.createElement('div');
            const learnMoreBtn = document.createElement('div');
            learnMoreBtn.classList.add("learn-more-btn")
            job.classList.add("job", teamCleanString, locationCleanString, commitmentCleanString, workplaceTypeCleanString);
            jobDetails.innerHTML = `<h3 class="job-title h5"><a class="job-title__link" href="${link}">${title}</a></h3>
                <p class="tags"><span>${team}, </span><span>${location}, </span><span>${commitment}, </span><span>${workplaceType}</span</p>
                `;
            learnMoreBtn.innerHTML = `<a class="button button--secondary" href="${link}" target="_blank">Learn more</a>`;

            job.append(jobDetails, learnMoreBtn);

            if(jobsListContainer) {
                jobsListContainer.appendChild(job);
            }
        }
    }
}

// Fetching job postings from Lever's postings API
const xhr = new XMLHttpRequest();
xhr.open("GET", url);
xhr.responseType = "json";
xhr.onload = function() {
    createJobs(xhr.response);
};
xhr.send();
